<template>
    <div class="my-4">
        <div class="w-full">
            <h1 class="text-3xl text-center">
                Roles en total
                <strong class="text-theme-primary">
                    {{ itemsCurrent.length }}
                </strong>
            </h1>
        </div>

        <div class="flex flex-wrap mt-2">
            <div
                class="flex flex-col lg:flex-row items-center justify-between w-full mt-3 gap-4"
            >
                <div
                    class="flex flex-wrap items-center justify-center lg:justify-start gap-2"
                >
                    <advanced-options-button
                        v-if="$ability.hasPermission('role:Sync')"
                        :options="rolesAdvancedOptions"
                        @option-click="onRolesAdvancedOptionClick"
                    />
                </div>

                <div
                    class="flex flex-wrap items-center justify-center lg:justify-end gap-3"
                >
                    <app-button
                        icon
                        circle
                        color="brand-purple"
                        @click="reloadRoles"
                    >
                        <reload-icon class="h-5 w-5 text-white" />
                    </app-button>
                    <list-settings-button :value="{ pageSize }" />
                </div>
            </div>
        </div>

        <div class="w-full mt-2">
            <custom-table
                :fields="$data.$fields"
                :per-page="itemsCurrent.length"
                :items="itemsCurrent"
                responsive
                outlined
                no-border-collapse
                hover
                class="w-full"
            >
                <template #cell(slug)="data">
                    <div class="flex items-center">
                        <router-link
                            :to="`/app/roles/detail/${data.item.slug}`"
                            class="text-center btn btn-stack-primary p-1"
                        >
                            <span>
                                {{ data.item.slug }}
                            </span>
                        </router-link>
                    </div>
                </template>
                <template #cell(name)="data">
                    <span class="text-center">
                        {{ data.item.name }}
                    </span>
                </template>
            </custom-table>
        </div>

        <app-dialog v-model="isOpenModalSync" size="lg">
            <template #header>
                <h1 class="text-3xl capitalize">
                    Roles y permisos creados # {{ itemsSync.length }}
                </h1>
            </template>
            <div>
                <role-view
                    v-for="(item, index) in itemsSync"
                    :key="index"
                    :role="item"
                />
            </div>
        </app-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { validateConfirmationMessage } from "@/common/lib/transformers";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import RoleView from "@/components/roles/RoleView.vue";
import AdvancedOptionsButton from "@/components/utils/AdvancedOptionsButton.vue";
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomTable from "@/components/utils/CustomTable.vue";

export default {
    name: "IndexRoles",
    components: {
        AppDialog,
        AdvancedOptionsButton,
        CustomTable,
        ReloadIcon,
        RoleView
    },
    layout: "app",
    data: () => ({
        isOpenModalSync: false,
        isLoading: false,
        itemsCurrent: [],
        pageSize: 24,

        itemsSync: [],
        $fields: [
            { key: "slug", label: "Slug", sortable: true },
            { key: "name", label: "Nombre", sortable: true }
        ]
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        rolesAdvancedOptions() {
            return [
                {
                    key: "sync",
                    icon: "♻",
                    label: "Sincronizar roles y permisos",
                    group: "action"
                }
            ];
        }
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("role:List", "/app"))) return;
        this.listAllRolesComponent();
    },
    methods: {
        ...mapActions("roles", ["listAllRoles", "syncRoles"]),
        async listAllRolesComponent(required = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const items = await this.listAllRoles({ required });
                this.isLoading = false;
                this.itemsCurrent = items;
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        onRolesAdvancedOptionClick(key) {
            if (key === "sync") this.syncRolesComponent();
        },
        async reloadRoles() {
            await this.listAllRolesComponent(true);
        },
        async syncRolesComponent() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Estas a punto de reiniciar el sistema de roles y permisos.",
                text: `Esta acción es unicamente permitida para el super usuario y solo debe de hacerse cuando se crean nuevas acciones,
                eres consiente de lo que estas haciendo ?. Escribe 'Si' para reiniciar`,
                icon: "info",
                input: "text",
                confirmButtonColor: "#ee3f59",
                cancelButtonColor: "#253C99",
                showCancelButton: true
            });
            if (
                dialogResult.isConfirmed &&
                validateConfirmationMessage(dialogResult.value)
            ) {
                try {
                    this.itemsSync = await this.syncRoles();
                    this.isOpenModalSync = true;
                    this.$sound.play();
                } catch (error) {
                    this.$sound.play("error");
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        }
    }
};
</script>
